"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ping = ping;
const AAPITypes_1 = require("../AAPITypes");
function ping(params) {
    params.currentClientTime =
        params.currentClientTime || new Date().toISOString();
    const correlationData = this.addToCorrelation(params);
    if (this.initializationParams.useJSON) {
        const request = {
            aapiId: AAPITypes_1.aapiId.ping,
            correlationId: correlationData.correlationDataId,
            currentClientTime: params.currentClientTime,
            lastPingRoundtripMS: params.lastPingRoundtripMS,
            lastPingedAt: params.lastPingedAt,
        };
        this._sendStreamingMessageJSON(request);
    }
    else {
        const request = {};
        request[0] = correlationData.correlationDataId;
        if (params.currentClientTime !== undefined)
            request[1] = params.currentClientTime;
        if (params.lastPingRoundtripMS !== undefined)
            request[2] = params.lastPingRoundtripMS;
        if (params.lastPingedAt !== undefined)
            request[3] = params.lastPingedAt;
        this._sendStreamingMessage(AAPITypes_1.aapiId.ping, request);
    }
    return correlationData.promise;
}
